import { Component, Input } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
  selector: 'app-address-form-error',
  templateUrl: './address-form-error.component.html',
  imports: [TranslocoModule]
})
export class AddressFormErrorComponent {
  @Input() message?: string;
  @Input() field: string;
}
